import { useAuth } from '../app/auth-context'
import { AlertIcon } from './icons'
import { Button } from './ui/Button'

/**
 * Covers whatever screen the customer was on when the API said `ACCOUNT_SUSPENDED` — OTP verify,
 * the refresh at load, or any request mid-session. They are already signed out by then; this is
 * the API's own sentence, said once and plainly, instead of a generic error or a silent bounce to
 * the login screen.
 *
 * It lives beside the router, not inside a route, because a suspension can land on any screen.
 */
export function SuspendedNotice() {
  const { suspendedMessage, dismissSuspended } = useAuth()
  if (!suspendedMessage) return null

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="suspended-title"
      aria-describedby="suspended-message"
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 sm:items-center"
    >
      <div className="safe-bottom w-full max-w-[430px] rounded-t-[var(--radius-card)] bg-page px-6 pb-4 pt-8 text-center sm:rounded-[var(--radius-card)]">
        <AlertIcon className="mx-auto h-12 w-12 text-red-600 dark:text-red-400" />
        <h2 id="suspended-title" className="mt-4 text-lg font-bold text-strong">
          حساب کاربری مسدود است
        </h2>
        <p id="suspended-message" className="mt-2 text-sm leading-7 text-muted">
          {suspendedMessage}
        </p>
        <Button autoFocus className="mt-6" onClick={dismissSuspended}>
          متوجه شدم
        </Button>
      </div>
    </div>
  )
}
